<template>
  <div class="modal-dialog">
    <div class="modal-content success-pop-up">
      <div class="modal-body">
        <button type="button" class="close resource-close" @click="closeVideo">
          &times;
        </button>
        <p class="success-message">{{ this.videoProcessData.title }}</p>
        <video class="video_size" id="getVideopause" controls :src="video"></video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "videoPopup",
  props: ["resourceDeleteId"],
  data() {
    return {
      video: "",
      studyId: this.$route.params.studyId,
      getfilePath: "",
      videoProcessData: ""
    };
  },
  methods: {
    closeVideo() {
      document.getElementById("getVideopause").pause();
      window.$("#material-video-pop").modal("hide");
    },
    async getVideodata() {
      const videofile = {
        studyId: this.studyId,
        filePath: this.videoProcessData.filePath
      };
      await this.$api.getPresignedURL(videofile).then(response => {
        setTimeout(() => {
          this.video = response.body.preSignedUrl;
        }, 500);
      });
    }
  },
  created() {
    this.$root.$on("getvideoProcess", data => {
      this.videoProcessData = data;
      this.getVideodata();
    });
  }
};
</script>

<style lang="scss" scoped>
.success-pop-up {
  width: 700px;
  height: 450px;
  margin: 0px 0 3.1px -82px;
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
}

button.resource-close {
  position: relative;
  left: 5px;
  bottom: 12px;
  font-size: 30px;
}

.success-message {
  font-size: 16px;
  width: 90%;
  font-weight: bold;
  position: relative;
  left: 20px;
  text-align: left;
  color: #666669;
  font-family: "RobotoRegular";
}

.button-position {
  text-align: center;
}

.video_size {
  width: 630px;
  height: 356px;
  margin: 0px 0px 0px 18px;
}
</style>
